import { formatInTimeZone, toZonedTime } from 'date-fns-tz'
import { isValid as DFisValid } from 'date-fns/isValid'
import { format as DFformat } from 'date-fns/format'
import { addDays } from 'date-fns/addDays'
import { addMonths } from 'date-fns/addMonths'

// keep it same as kratos
export const MOVE_IN_DATE_OPTIONS: { value: string; label: string }[] = [
  {
    value: 'asap',
    label: 'As soon as possible'
  },
  {
    value: 'next_30_days',
    label: 'In the next 30 days'
  },
  {
    value: 'next_90_days',
    label: 'In the next 3 months'
  },
  {
    value: 'custom',
    label: 'Custom date'
  }
]

export const getLocalizedDateAs = function (date: Date | string, format: string) {
  const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const localDate = toZonedTime(date, localTimeZone)
  return formatInTimeZone(localDate, localTimeZone, format)
}

export const getMoveInDate = function (move_in_date: string) {
  const dateFormatStr = 'MM/dd/yy'

  if (move_in_date === 'asap') {
    return DFformat(new Date(), dateFormatStr)
  } else if (move_in_date === 'next_30_days') {
    return DFformat(addDays(new Date(), 30), dateFormatStr)
  } else if (move_in_date === 'next_90_days') {
    return DFformat(addMonths(new Date(), 3), dateFormatStr)
  } else {
    if (!DFisValid(new Date(move_in_date))) {
      return 'unknown'
    }
    return getLocalizedDateAs(move_in_date, dateFormatStr)
  }
}
